import React, { useEffect, useRef, useState } from 'react';
import './CardOne.css';
import image from './scratch-image-background-two.png';
import day13 from './13.png';
import day14 from './14.png';
import day15 from './15.png';
import day16 from './16.png';
import day17 from './17.png';
import day18 from './18.png';
import day19 from './19.png';
import day20 from './20.png';
import day21 from './21.png';
import day22 from './22.png';
import day23 from './23.png';
import day24 from './24.png';
import { useNavigate } from 'react-router-dom';

function ScratchCard() {
    const navigate = useNavigate();
    const canvasRef = useRef(null);
    const imgRef = useRef(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      document.title = "Kamasutra Adventskalendar";
      const canvas = canvasRef.current;
      const img = imgRef.current;
      const ctx = canvas.getContext('2d');
      
      const images = [
        day13, day14, day15,
        day16, day17, day18,
        day19, day20, day21,
        day22, day23, day24
      ];
      
      const loadedImages = images.map(src => {
        const img = new Image();
        img.src = src;
        return img;
      });
  
      // Define your circle data
      const circlesData = [
        { x: 63, y: 215, radius: 41, image: loadedImages[0] },
        { x: 178, y: 215, radius: 41, image: loadedImages[1] },
        { x: 295, y: 215, radius: 41, image: loadedImages[2] },
    
        { x: 63, y: 307, radius: 41, image: loadedImages[3] },
        { x: 178, y: 307, radius: 41, image: loadedImages[4] },
        { x: 295, y: 307, radius: 41, image: loadedImages[5] },
    
        { x: 63, y: 400, radius: 41, image: loadedImages[6] },
        { x: 178, y: 400, radius: 41, image: loadedImages[7] },
        { x: 295, y: 400, radius: 41, image: loadedImages[8] },
    
        { x: 63, y: 498, radius: 41, image: loadedImages[9] },
        { x: 178, y: 498, radius: 41, image: loadedImages[10] },
        { x: 295, y: 498, radius: 41,image: loadedImages[11] },
    ];
  
      let circles = []; // This will store scaled circle data
  
      function updateCirclePositions() {
        const scaleX = canvas.width / 360;
        const scaleY = canvas.height / 640;
        circles = circlesData.map(circle => ({
          x: circle.x * scaleX,
          y: circle.y * scaleY,
          radius: circle.radius * Math.min(scaleX, scaleY),
          image: circle.image
        }));
      }
  
      function drawCircles() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#cccccc';
        circles.forEach(circle => {
          const imageWidth = circle.radius * 2;
          const imageHeight = circle.radius * 2;
          const imageX = circle.x - imageWidth / 2;
          const imageY = circle.y - imageHeight / 2;
          ctx.drawImage(circle.image, imageX, imageY, imageWidth, imageHeight);
        });
        ctx.globalCompositeOperation = 'destination-out';
      }
  
      function resizeCanvas() {
        canvas.width = img.width;
        canvas.height = img.height;
        updateCirclePositions();
        drawCircles();
      }
  
      loadedImages.forEach(image => {
        image.onload = () => {
          resizeCanvas(); // Resize canvas once all custom shape images are loaded
        };
      });
  
      // Resize canvas on page load
      resizeCanvas();
  
      // Listen for resize events to adjust canvas and circle sizes
      window.addEventListener('resize', resizeCanvas);
  
      if (img.complete) {
        resizeCanvas(); // If the image is already loaded (e.g., cached), resize immediately
      } else {
        img.onload = resizeCanvas; // Wait for the image to load before resizing
      }
  
      function getCoordinates(e) {
        const rect = canvas.getBoundingClientRect();
        let x, y;
  
        if (e.touches) {
          x = e.touches[0].clientX - rect.left;
          y = e.touches[0].clientY - rect.top;
        } else {
          x = e.clientX - rect.left;
          y = e.clientY - rect.top;
        }
  
        return { x, y };
      }
  
      let lastX, lastY, isDrawing = false;
  
      function scratch(e) {
        const { x, y } = getCoordinates(e);
  
        if (isDrawing) {
          if (lastX == null || lastY == null) {
            lastX = x; // Set starting position if not already set
            lastY = y;
          }
        }
  
        circles.forEach(circle => {
          const distance = Math.sqrt((x - circle.x) ** 2 + (y - circle.y) ** 2);
          if (distance < circle.radius) {
            ctx.lineWidth = 15;
            ctx.beginPath();
            ctx.moveTo(lastX, lastY);
            ctx.lineTo(x, y);
            ctx.stroke();
            ctx.closePath();
          }
        });
  
        [lastX, lastY] = [x, y];
      }
  
      // Mouse event listeners
      canvas.addEventListener('mousedown', function (e) {
        isDrawing = true; // Start drawing
        lastX = null; // Reset lastX and lastY
        lastY = null;
        scratch(e); // Handle initial touch point
      });
  
      canvas.addEventListener('mousemove', function (e) {
        if (isDrawing) {
          scratch(e);
        }
      });
  
      canvas.addEventListener('mouseup', function () {
        isDrawing = false; // Stop drawing
      });
  
      canvas.addEventListener('mouseout', function () {
        isDrawing = false; // Stop drawing when the cursor leaves the canvas
      });
  
      canvas.addEventListener('touchstart', function (e) {
        e.preventDefault(); // Prevent scrolling and other default actions
        isDrawing = true;
        lastX = null; // Reset lastX and lastY
        lastY = null;
        scratch(e.touches[0]); // Use the first touch point to start
      });
  
      canvas.addEventListener('touchmove', function (e) {
        e.preventDefault();
        if (isDrawing) {
          scratch(e.touches[0]); // Continue with the first touch point
        }
      });
  
      canvas.addEventListener('touchend', function (e) {
        isDrawing = false; // Stop drawing when touch ends
      });
  
      canvas.addEventListener('touchcancel', function (e) {
        isDrawing = false; // Also stop drawing when touch is interrupted
      });
  
      setTimeout(() => {
        setLoading(false);
      }, 1000); // Hide the spinner after 1 second
    }, []);
  
    return (
      <div className="scratch-card">
        {loading && (
          <div className="spinner-overlay">
            <div className="spinner"></div>
          </div>
        )}
        <canvas ref={canvasRef} id="scratchCanvas"></canvas>
        <img ref={imgRef} src={image} alt="Scratch Card" />
        <button className="navigate-button" style={{ fontSize: '20px' }} onClick={() => navigate('/kamasutra-adventskalendar-part-one?token=vatghrahtbhrba')}>CLICK FOR DAYS 1 TO 12</button>
      </div>
    );
  }
  
  export default ScratchCard;

